
import React from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw, WifiOff, UserCheck, Database } from "lucide-react";

interface ErrorDisplayProps {
  errorMessage: string | null;
  onRetry: () => void;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ errorMessage, onRetry }) => {
  // Detect specific error types to show tailored messages
  const isNetworkError = errorMessage?.includes("Nätverksfel") || 
                         errorMessage?.includes("Failed to fetch") || 
                         errorMessage?.includes("internet");
                         
  const isAuthError = errorMessage?.includes("inloggning") || 
                      errorMessage?.includes("JWT") || 
                      errorMessage?.includes("logga in");
                      
  const isDataError = errorMessage?.includes("tomt") || 
                      errorMessage?.includes("inga projekt") ||
                      errorMessage?.includes("data");

  return (
    <div className="p-8 bg-red-50 border border-red-200 rounded-lg flex flex-col items-center justify-center text-center">
      {isNetworkError ? (
        <WifiOff className="h-12 w-12 text-red-500 mb-4" />
      ) : isAuthError ? (
        <UserCheck className="h-12 w-12 text-red-500 mb-4" />
      ) : isDataError ? (
        <Database className="h-12 w-12 text-red-500 mb-4" />
      ) : (
        <AlertTriangle className="h-12 w-12 text-red-500 mb-4" />
      )}
      
      <h3 className="text-lg font-medium text-red-800 mb-2">
        {isNetworkError ? "Anslutningsproblem" : 
         isAuthError ? "Inloggningsproblem" : 
         isDataError ? "Problem med att ladda data" :
         "Kunde inte ladda dina uppdrag"}
      </h3>
      
      <p className="text-red-600 mb-4 max-w-md">{errorMessage}</p>
      
      {isNetworkError && (
        <div className="text-sm text-red-600 mb-4 max-w-md">
          <p className="font-medium mb-1">Kontrollera:</p>
          <ul className="list-disc pl-6 text-left">
            <li>Din internetanslutning</li>
            <li>Om servern är tillgänglig</li>
            <li>Brandväggsinställningar</li>
          </ul>
        </div>
      )}
      
      {isAuthError && (
        <div className="text-sm text-red-600 mb-4 max-w-md">
          <p className="font-medium mb-1">Förslag:</p>
          <ul className="list-disc pl-6 text-left">
            <li>Logga ut och in igen</li>
            <li>Kontrollera om din session har gått ut</li>
            <li>Rensa webbläsarens cache</li>
          </ul>
        </div>
      )}
      
      {isDataError && (
        <div className="text-sm text-red-600 mb-4 max-w-md">
          <p className="font-medium mb-1">Förslag:</p>
          <ul className="list-disc pl-6 text-left">
            <li>Skapa ett nytt projekt om du inte har några än</li>
            <li>Kontrollera dina inställningar</li>
            <li>Uppdatera sidan</li>
          </ul>
        </div>
      )}
      
      <Button 
        onClick={onRetry} 
        variant="outline" 
        className="flex items-center gap-2"
      >
        <RefreshCw className="h-4 w-4" />
        Försök igen
      </Button>
    </div>
  );
};

export default ErrorDisplay;
